import React, { useCallback } from 'react';
import { useState } from 'react';
import { styled } from 'baseui';
import { Banner, HIERARCHY, KIND } from 'baseui/banner';
import Loader from '../common/loader';
import { TASK_MODE } from '../common/task-state/constants';
import { Studio } from './component/studio';
import TaskHeader from './component/task-header';
import { useGetTask } from './hooks/use-get-task';
import { getYoloGeneratedData } from './utils';
const TaskContainer = styled('div', ({
  $theme
}) => ({
  display: 'flex',
  flexDirection: 'column',
  height: '100vh',
  marginBottom: $theme.sizing.scale100,
  position: 'relative'
}));
const TaskContent = styled('div', {
  display: 'flex',
  height: '100%',
  overflow: 'auto'
});
const LoadingContainer = styled('div', {
  display: 'flex',
  height: '100vh',
  justifyContent: 'center',
  alignItems: 'center'
});
export const PreviewPage = () => {
  const [taskId, setTaskId] = useState<number>();
  const {
    data,
    isLoading,
    error
  } = useGetTask(taskId);
  const input = data?.task.input;
  const getYoloData = useCallback(() => {
    return getYoloGeneratedData(input);
  }, [input]);
  if (isLoading) {
    return <LoadingContainer>
        <Loader />
      </LoadingContainer>;
  }
  return <TaskContainer>
      <TaskHeader mode={'Preview'} onPreviewTask={taskId => {
      setTaskId(taskId);
    }} />
      {error && <>
          <Banner title="Error" hierarchy={HIERARCHY.high} kind={KIND.negative}>
            {error.message}
          </Banner>
        </>}
      <TaskContent>
        {data?.task.output && <Studio key={taskId} inputData={{
        ...data.task.input,
        ...data.task.output,
        ...(data.task.input.labellingType === 'VIDEO' ? {
          multiVideoList: [{
            url: data.task.input.videoUrl,
            label: 'Main Video',
            referenceUri: 'main-media-reference'
          }]
        } : {}),
        taskState: {
          readOnly: false,
          taskModes: [TASK_MODE.EDIT, ...(data.task.state?.toUpperCase() === TASK_MODE.REVIEW ? [TASK_MODE.REVIEW] : [])]
        }
      }} annotationLabels={data.project.configuration.annotationLabel}
      // @ts-expect-error todo(ts-migration) TS2322 Type '(questionnaireId: string) => Promise<QnAStateType | undefined>' is not assignable to type '(questionnaireId: string) => Promise<QnAStateType>'.
      fetchQuestionnaire={async (questionnaireId: string) => {
        return data.project.configuration.questionnaires[questionnaireId]?.questionnaire;
      }} questionnaires={data?.project.configuration.questionnaires} questionnairePreAnnotation={data.task.output.taskLevelQuestionnaire} onAnswerChange={() => {}} onStoreChange={() => {}} getYoloData={getYoloData} taskLevelQuestionnaire={data.project.taskLevelQuestionnaire} getSignedUrl={() => Promise.resolve('')} isReviewMode={data.task.state?.toUpperCase() === TASK_MODE.REVIEW} />}
      </TaskContent>
    </TaskContainer>;
};